import { Controller } from "stimulus";
import { EventCheckUserLogin } from "../constants/events";
import Cookies from "js-cookie";
import { followCategory, unfollowCategory } from "./following_categories/shared_functions";

export default class extends Controller {

  connect() {
    window.addEventListener(EventCheckUserLogin, e => {
      this.loggedIn = e.detail.userLoggedIn;
    });
  }

  follow(e) {
    if (this.loggedIn) {
      this._followCategory(e);
    } else {
      const categorySlug = e.currentTarget.getAttribute("data-category-slug");

      Cookies.set("categorySlug", categorySlug);
      Cookies.set("followingCategoryRedirect", window.location.href);
    }
  }

  unfollow(e) {
    const categorySlug = e.currentTarget.getAttribute("data-category-slug");

    unfollowCategory(() => {
      this._toggleFollowButton(false);
    }, categorySlug);
  }

  _toggleFollowButton(showFollowing) {
    const categoryFollowingButtons = document.querySelectorAll("#category-following-button");
    const categoryFollowButtons = document.querySelectorAll("#category-follow-button");

    categoryFollowingButtons.forEach(button => {
      button.classList.toggle("tw-block", showFollowing);
      button.classList.toggle("tw-hidden", !showFollowing);
    });

    categoryFollowButtons.forEach(button => {
      button.classList.toggle("tw-block", !showFollowing);
      button.classList.toggle("tw-hidden", showFollowing);
    });
  }


  _followCategory(e) {
    const categorySlug = e.currentTarget.getAttribute("data-category-slug");

    followCategory(() => {
      this._toggleFollowButton(true);
    }, categorySlug);
  }
}
